export default "__VITE_ASSET__0378bb0f__"